import { css } from 'aphrodite';
import * as React from 'react';
import { ResourceAutoCompleteViewModelType } from '../../../../../extViewmodels';
import {
	ISimpleAutoCompleteSearchFieldItemSelectionEvent,
	SimpleAutoCompleteSearchField,
} from '../../../../../web/components/autocomplete/SimpleAutoCompleteSearchField';
import { styleSheet } from '../../styles';
import { SelectedItem } from './SelectedItem';

export interface ISelectionPickerItem {
	id: string;
	name: string;
}

interface IProps<TSelection> {
	items: ISelectionPickerItem[];
	onAdd: (selection: TSelection) => void;
	onRemove: (id: string) => void;
	placeholder: string;
	type: ResourceAutoCompleteViewModelType;
}

export function SelectionPicker<TSelection>({ items, onAdd, onRemove, placeholder, type }: IProps<TSelection>) {
	const handleItemSelected = (event: ISimpleAutoCompleteSearchFieldItemSelectionEvent<unknown>) =>
		onAdd(event.selection as TSelection);

	return (
		<div className={css(styleSheet.radioContent)}>
			<SimpleAutoCompleteSearchField
				initialSearchQuery=''
				onItemSelected={handleItemSelected}
				pageSize={5}
				placeholder={placeholder}
				resultsLimit={5}
				type={type}
			/>
			{items.map(item => (
				<SelectedItem key={item.id} name={item.name} onRemove={() => onRemove(item.id)} />
			))}
		</div>
	);
}
